import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getBalance = createAsyncThunk(
  "balance/getBalance",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;
      const filterStr = filterRequest(filter);
      const params = new URLSearchParams();

      // Only add non-empty params
      if (page) params.append("page", page);
      if (size) params.append("size", size);
      if (query) params.append("query", query);
      if (owner) params.append("owner", owner);
      if (user) params.append("user", user);

      const url = `/balance${params.toString() ? '?' + params.toString() : ''}${filterStr}`;

      const response = await axiosInstance.get(url);
      const { data: balanceArray, itemsCount, pages } = response.data.data;
      return thunkApi.fulfillWithValue({ data: balanceArray, itemsCount, pages });
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createBalance = createAsyncThunk(
  "balance/createBalance",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/dyarko-transactions`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const balanceSlice = createSlice({
  name: "balance",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getBalance.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getBalance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getBalance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createBalance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createBalance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createBalance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default balanceSlice.reducer;